"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls_1) {
        $(document).ready(function () {
            // Global handlers to update key-pressed state.
            var keyPressAttribute = "data-dyn-key-pressed";
            var metaKeyAttributeValue = "meta";
            $(document).on("keydown", function (e) {
                if (e.keyCode === $dyn.ui.KeyCodes.ctrl) {
                    document.body.setAttribute(keyPressAttribute, metaKeyAttributeValue);
                }
            });
            $(document).on("keyup", function (e) {
                if (e.keyCode === $dyn.ui.KeyCodes.ctrl) {
                    document.body.removeAttribute(keyPressAttribute);
                }
            });
        });
        /**
         * Framework base class for Edit controls
         */
        var Edit = /** @class */ (function (_super) {
            __extends(Edit, _super);
            function Edit() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            /**
             * Tells whether or not the control is in the inactive row in the grid
             * @returns Whether or not the control is the inactive row control
             */
            Edit.prototype.isInactiveCell = function () {
                if (this._isInactiveCell === undefined && this.element) {
                    this._isInactiveCell = this.element.classList.contains("isInactiveCell");
                }
                return this._isInactiveCell;
            };
            Edit.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                switch (this.TypeName) {
                    case "InputSummary":
                    case "MultilineInputSummary":
                    case "RealSummary":
                    case "IntegerSummary":
                    case "Int64Summary":
                    case "DateSummary":
                    case "DateTimeSummary":
                    case "TimeSummary":
                    case "ComboBoxSummary":
                        // CanAcquireFocus is poorly named but this allows the selection of the control to skip notifying the server that the selection changed
                        this.CanAcquireFocus = false;
                        break;
                    default:
                        break;
                }
                this.$cachedElement = $(element);
                this.IsShowingMandatoryIndicator = $dyn.computed(function () {
                    return $dyn.value(_this.StatusIndicator) === $dyn.ui.StatusIndicator.mandatory;
                });
                this.IsShowingWarningIndicator = $dyn.computed(function () {
                    return $dyn.value(_this.StatusIndicator) === $dyn.ui.StatusIndicator.warning;
                });
                this.innerListIndexObserver = null;
                this.innerListDataChanged = null;
                if (!this.isInactiveCell()) {
                    $dyn.observe(this.HasMessages, function () {
                        _this.UpdateStatusArea();
                    }, this, undefined, true);
                    $dyn.observe(this.Required, function () {
                        _this.UpdateStatusArea();
                    }, this, undefined, true);
                    $dyn.observe(this.Visible, function () {
                        _this.UpdateStatusArea();
                    }, this, undefined, true);
                    // Call this only once within init at the end
                    this.UpdateStatusArea();
                }
            };
            Object.defineProperty(Edit.prototype, "StatusArea", {
                /* Validation related css classes
                        field-status     - element is a status area
                        Required-symbol  - a glyph (*)
                        Warning-symbol   - a glyph (!)
                        hidden           - hide the status area
                        statusMandatory  - sets the color for glyph
                        statusWarning    - sets the color for glyph
                        validationFailed - adds padding to input element so indicator doesn't cover data */
                /**
                 * The jQuery wrapper of the control's field-status element
                 */
                get: function () {
                    if (this._statusArea === undefined && this.element && !this.ReferenceGroup) {
                        // If this control is contained in a lookup container don't hook up the controls
                        // StatusArea at this time.  When controls are added to a lookup we'll hook
                        // to the first control's StatusArea.
                        var foundStatusArea = this.$cachedElement.find(".field-status").first();
                        if (foundStatusArea.length === 0) {
                            foundStatusArea = null;
                        }
                        this._statusArea = foundStatusArea;
                    }
                    return this._statusArea;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Recalculates and displays the indicator
             */
            Edit.prototype.UpdateStatusArea = function () {
                // Do not Update the status area if the current control can not show a status indicator
                if (this.StatusArea && !this.ReferenceGroup) {
                    if (!this.isInactiveCell()) {
                        var editable = this.allowUserChanges();
                        if ($dyn.value(this.IsValid) === false) {
                            this.StatusIndicator($dyn.ui.StatusIndicator.warning);
                        }
                        else if ($dyn.value(this.HasMessages)) {
                            // possible that the message from the server is a failure to supply a mandatory value.
                            if ($dyn.value(this.Required) && editable && this.isMandatoryMet && this.isMandatoryMet() === false) {
                                this.StatusIndicator($dyn.ui.StatusIndicator.mandatory);
                            }
                            else {
                                this.StatusIndicator($dyn.ui.StatusIndicator.warning);
                            }
                        }
                        else {
                            if ($dyn.value(this.Required) && editable) {
                                // if this control is marked as mandatory and
                                // the control does not have a value then
                                // show the mandatory indicator
                                if (this.isMandatoryMet && this.isMandatoryMet() === false) {
                                    if ($dyn.value(this.isFocused) && $dyn.value(this.AllowEdit)) {
                                        this.StatusIndicator($dyn.ui.StatusIndicator.none);
                                    }
                                    else {
                                        this.StatusIndicator($dyn.ui.StatusIndicator.mandatory);
                                    }
                                }
                                else {
                                    this.StatusIndicator($dyn.ui.StatusIndicator.none);
                                }
                            }
                            else {
                                // Validation has passed and this control does not require
                                // a value (not mandatory).  Therefore, if any indicator is
                                // currently being shown it can be hidden.
                                this.StatusIndicator($dyn.ui.StatusIndicator.none);
                            }
                        }
                    }
                    else {
                        this.StatusIndicator($dyn.ui.StatusIndicator.none);
                    }
                }
                else if (this.ReferenceGroup) {
                    // Update the ReferenceGroup
                    this.ReferenceGroup.UpdateStatusArea();
                }
            };
            /**
             * Add a message to the control's associated messages array
             * @param messageId The id of the associated message
             */
            Edit.prototype.addMessage = function (messageId) {
                if (this.ReferenceGroup) {
                    this.ReferenceGroup.addMessage(messageId);
                }
                else {
                    if (!this.messages) {
                        this.messages = [];
                    }
                    this.messages.push(messageId);
                    this.HasMessages(true);
                }
            };
            /**
             * Remove a message from the control's associated messages array
             * @param messageId The id of the message
             */
            Edit.prototype.removeMessageFromControl = function (messageId) {
                if (this.ReferenceGroup) {
                    this.ReferenceGroup.removeMessageFromControl(messageId);
                }
                else if ($dyn.length(this.messages) > 0) {
                    for (var i = 0; i < this.messages.length; i++) {
                        if (messageId === this.messages[i]) {
                            this.messages.splice(i, 1);
                            if ($dyn.length(this.messages) === 0) {
                                this.HasMessages(false);
                            }
                            break;
                        }
                    }
                }
            };
            /**
             * Add a warning message for this control
             * @param message The text to be displayed in the message
             * @param label The Dynamics label used
             * @returns Returns the logged message Id
             */
            Edit.prototype.warn = function (message, label) {
                return $dyn.warn({ Message: message, Label: label }, this);
            };
            Edit.prototype.getTaskGuideParams = function (options) {
                options = _super.prototype.getTaskGuideParams.call(this, options);
                var target = $(this.element);
                var commandName = options.action;
                if (commandName && commandName.indexOf("RequestPopup") !== -1) {
                    // If this control is in a ReferenceGroup and is requesting a lookup
                    // the task guide should point to the ReferenceGroup lookup dock
                    if (this.ReferenceGroup) {
                        target = $(this.ReferenceGroup.element).children(".lookupDock");
                    }
                    var flyoutDiv = $(".lookup-popup.active-form");
                    if (flyoutDiv && flyoutDiv.length === 1) {
                        target = flyoutDiv;
                    }
                    if ($dyn.ui.isPopupHost(this) && !this._popupOpenObserver) {
                        this._popupOpenObserver = $dyn.observe(this.Popup, function () {
                            if ($dyn.ax && $dyn.ax.taskGuide && $dyn.ax.taskGuide.repositionGuidedQtip && !$dyn.value($dyn.ax.taskGuide.repositionGuidedQtip)) {
                                $dyn.async(function () {
                                    $dyn.ax.taskGuide.repositionGuidedQtip(true);
                                }, 0, "reset task guide qtip");
                            }
                        });
                    }
                }
                options.target = target;
                return options;
            };
            /**
             * Adds screen reader pronouncing of grid's rows inside of a lookup
             */
            Edit.prototype.setupAccessibilityForLookup = function () {
                var _this = this;
                if ($dyn.ui.isPopupHost(this)) {
                    var lookupForm_1 = $dyn.context(this.popupHostElement);
                    if (lookupForm_1 && lookupForm_1.readyStatePromise) {
                        $.when(lookupForm_1.readyStatePromise).done(function () {
                            var listElement = $(lookupForm_1.element).find("[data-dyn-role='List']")[0];
                            if (listElement) {
                                var innerList_1 = $dyn.context(listElement);
                                if (innerList_1) {
                                    var readAccessibleLabel_1 = function (newIndex, initialLabelValue) {
                                        if ($dyn.ui.isPopupHost(_this)) {
                                            var $listItems = $(_this.popupHostElement).find(".rowTemplate");
                                            if ($listItems.length > 0) {
                                                var $selectedRow = $listItems.eq(newIndex);
                                                // tslint:disable-next-line:no-shadowed-variable
                                                var controls_2 = $selectedRow.find(".listCell");
                                                if (controls_2.length > 0) {
                                                    var controlLabel = initialLabelValue;
                                                    // tslint:disable-next-line:prefer-for-of
                                                    for (var i = 0; i < controls_2.length; i++) {
                                                        var $control = $(controls_2[i]).find("input");
                                                        if ($control.length > 0 && $control.parent()) {
                                                            var textToRead = "";
                                                            var colIndex = $control.parent().attr("data-colindex");
                                                            var $headerElement = $(listElement).find(".listHeader [data-colindex='" + colIndex + "']");
                                                            if ($headerElement) {
                                                                var headerLabel = $(listElement).find(".listHeader [data-colindex='" + colIndex + "']").text();
                                                                if (headerLabel) {
                                                                    textToRead = headerLabel + " " + $control.val() + " ";
                                                                }
                                                                else {
                                                                    textToRead = $control.val() + " ";
                                                                }
                                                                if (textToRead) {
                                                                    if (!controlLabel) {
                                                                        controlLabel = textToRead;
                                                                    }
                                                                    else {
                                                                        controlLabel = controlLabel + textToRead;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if (controlLabel) {
                                                        $dyn.shell.addAriaAlertMessage(controlLabel);
                                                    }
                                                }
                                            }
                                        }
                                    };
                                    var originalPostRenderFunction_1 = innerList_1.PostRender;
                                    innerList_1.PostRender = function (args) {
                                        readAccessibleLabel_1($dyn.value(innerList_1.SelectedIndex), $dyn.label("Tree_ExpandedText"));
                                        if (originalPostRenderFunction_1) {
                                            originalPostRenderFunction_1(args);
                                        }
                                    };
                                    _this.innerListDataChanged = $dyn.observe(innerList_1._dataChangedVersion, function () {
                                        _this.innerListIndexObserver = $dyn.observe(innerList_1.SelectedIndex, function (newIndex) {
                                            // Speak label for all the control in selected row
                                            readAccessibleLabel_1(newIndex, "");
                                        }, _this, _this.innerListIndexObserver);
                                    }, _this, _this.innerListDataChanged);
                                }
                            }
                        });
                    }
                }
            };
            /**
             * Sets the pending popup that has been requested but not returned yet
             * @param pendingPopup The pending popup
             */
            Edit.prototype.pendingPopup = function (pendingPopup) {
                this._pendingPopup = pendingPopup;
            };
            /**
             * Gets the current loading animation object
             * @returns The current loading animation object if applicable, otherwise undefined
             */
            Edit.prototype.getActiveIsLoadingAnimation = function () {
                return this._activeIsLoadingAnimation;
            };
            /**
             * Sets the current loading animation object
             * @param activeIsLoadingAnimation The current loading animation object
             */
            Edit.prototype.setActiveIsLoadingAnimation = function (activeIsLoadingAnimation) {
                this._activeIsLoadingAnimation = activeIsLoadingAnimation;
            };
            /**
             * Cleans up all the flyout related state on the control
             * @param chainToRefGroup Whether or not to chain the call to the parent reference group if defined
             */
            Edit.prototype.focusOutCleanup = function (chainToRefGroup) {
                if (chainToRefGroup === void 0) { chainToRefGroup = false; }
                // Do not close lookup on focus out if it is isPhone
                if ($dyn.shell.isPhone && $dyn.value(this.LookupButton) && $dyn.value(this.CanOpenLookupForm)) {
                    return;
                }
                if (this._pendingPopup) {
                    if ($dyn.log.popups) {
                        $dyn.log.popups("Popups: Focus removed from %s / %s; cancelling pending popup", this.Name ? this.Name : "<unknown>", (this._element && this._element.id) ? this._element.id : "<unknown>");
                    }
                    this._pendingPopup.cancel();
                }
                else if (this.ShowFlyout) {
                    if ($dyn.log.popups) {
                        $dyn.log.popups("Popups: Focus removed from %s / %s; setting ShowFlyout to false", this.Name ? this.Name : "<unknown>", (this._element && this._element.id) ? this._element.id : "<unknown>");
                    }
                    $dyn.setValue(this, "ShowFlyout", false);
                }
                if (this._activeIsLoadingAnimation) {
                    this._activeIsLoadingAnimation.cancel();
                }
                if (this.autoPresentLookupTimer && !this.enterLookupTimer) {
                    this.autoPresentLookupTimer.cancel();
                    this.autoPresentLookupTimer = undefined;
                }
                // Note: Only call on ref group in certain scenarios. There are several places where we do special behavior for Ref Group, which gets us into
                // this code path when we wouldn't have normally. To avoid this problems no-op unless in a scenario where we specifically want to update Reference Group.
                if (chainToRefGroup && this.ReferenceGroup) {
                    this.ReferenceGroup.focusOutCleanup();
                }
            };
            /**
             * This will attempt to get the lookup interaction target, which will be the grid at this point
             * @returns Returns the grid in the lookup if applicable, otherwise undefined
             */
            Edit.prototype.getLookupInteractionTarget = function () {
                var target;
                if ($dyn.ui.isPopupHost(this)) {
                    var grid = void 0;
                    var context_1 = $dyn.context(this.popupHostElement);
                    if (context_1 && context_1.UseReactGrid()) {
                        grid = $(this.popupHostElement).find("[data-dyn-role='ReactList']");
                    }
                    else {
                        grid = $(this.popupHostElement).find("[role='grid']");
                    }
                    if (grid[0]) {
                        target = grid[0];
                    }
                }
                return target;
            };
            /**
             * handle the click event on fieldOptions input element of the control
             */
            Edit.prototype.clickedFieldStatus = function () {
                // first call focus to set focus on the field they are clicking
                this.focusInput();
                // are we in view mode and need to go to edit mode
                var activeForm = $dyn.context($dyn.shell.getActiveForm());
                if (activeForm && activeForm.CanSwitchViewMode() && activeForm.IsInViewMode()) {
                    if (this.element.getAttribute("dyn-data-fieldoptions")) {
                        var event_1 = $.Event("keydown");
                        event_1.which = $dyn.ui.KeyCodes.f2;
                        activeForm.executeShortcuts(true, "ViewEdit", event_1);
                        $dyn.fieldOptions.fieldOptionsRemove(this.element);
                    }
                }
            };
            /**
             * Function used to override the FindFocusTarget on the flyout form
             * @returns Element to focus when the lookup opens
             */
            Edit.prototype.FindFocusTarget = function () {
                return this.$cachedElement;
            };
            /**
             * Handler for the keydown event for lookups. Forwards the keydown event to the lookup form if it is open.
             * @param evt The keydown event on the control
             * @returns Whether or not caller should stop propagation and call prevent default on the keydown event
             */
            Edit.prototype.handleKeyDownForLookup = function (evt) {
                var _this = this;
                var stopPropagationAndPreventDefault = false;
                if (this.SendKeyToLookup && $dyn.value(this.ShowFlyout) && evt) {
                    if ($dyn.log.popups) {
                        $dyn.log.popups("Popups: Forwarding keystroke to lookup for %s / %s", this.Name ? this.Name : "<unknown>", (this._element && this._element.id) ? this._element.id : "<unknown>");
                    }
                    var lookupInteractionTarget_1 = this.getLookupInteractionTarget();
                    if (lookupInteractionTarget_1) {
                        var sendKeyToGrid = function () {
                            if (_this.enterLookupTimer) {
                                _this.enterLookupTimer = undefined;
                            }
                            var lookupInteractionTargetContext = $dyn.context(lookupInteractionTarget_1);
                            if (lookupInteractionTargetContext) {
                                if (lookupInteractionTargetContext.Root && lookupInteractionTargetContext.Root.UseReactGrid()) {
                                    if (lookupInteractionTargetContext.ControlLibGridRef) {
                                        var gridOuterDiv = lookupInteractionTargetContext.ControlLibGridRef.getDivRef();
                                        if (gridOuterDiv) {
                                            var newEvent = new KeyboardEvent("keydown", {
                                                altKey: evt.altKey,
                                                bubbles: true,
                                                code: evt.key,
                                                ctrlKey: evt.ctrlKey,
                                                key: evt.key,
                                                shiftKey: evt.shiftKey,
                                            });
                                            gridOuterDiv.dispatchEvent(newEvent);
                                        }
                                    }
                                }
                                else {
                                    lookupInteractionTargetContext.RowKeyDown(evt);
                                }
                            }
                        };
                        // If the timeout to filter the flyout has started, make sure to send the enter after we send the filter
                        if (this.autoPresentLookupTimer && $dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.enter })) {
                            var timerLength = $dyn.ui.typeAheadTimer;
                            if ($dyn.debug.typeAheadTimer !== undefined) {
                                timerLength = $dyn.debug.typeAheadTimer;
                            }
                            this.enterLookupTimer = $dyn.async(sendKeyToGrid, timerLength, "Sending enter to lookup grid", this);
                        }
                        else {
                            $dyn.callFunction(sendKeyToGrid, this);
                        }
                    }
                    stopPropagationAndPreventDefault = true;
                }
                return stopPropagationAndPreventDefault;
            };
            /**
             * Includes the refererence group, if applicable, in the IsValid calculation
             * @returns false if control or reference group are invalid; otherwise false
             */
            Edit.prototype.controlIsValid = function () {
                return $dyn.value(this.IsValid) && (this.ReferenceGroup ? $dyn.value(this.ReferenceGroup.IsValid) : true);
            };
            Edit.prototype.attached = function () {
                _super.prototype.attached.call(this);
                this.$cachedElement = $(this.element);
            };
            /**
             * Get the control we will grab the filter value out of
             * @param event The keyboard event on the control
             * @returns The control we will grab the display value from to use for filtering
             */
            Edit.prototype.getDisplayedValueSource = function (event) {
                return this;
            };
            /**
             * Calculates a string which concatenates the top messages.
             * @param maxShown The maximum number of messages to include in the string.
             * @returns A string containing the concatenated messages.
             */
            Edit.prototype.getMessageString = function (maxShown) {
                var e_1, _a;
                if (maxShown === void 0) { maxShown = 6; }
                if (this.ReferenceGroup) {
                    return this.ReferenceGroup.getMessageString(maxShown);
                }
                if (!this.messages) {
                    this.messages = [];
                }
                var text = "";
                var numShown = 0;
                if (this.Root && this.Root.MessageBar) {
                    try {
                        for (var _b = __values(this.messages), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var messageId = _c.value;
                            var msg = this.Root.MessageBar.GetMessage(messageId);
                            if (msg) {
                                if (numShown > 0) {
                                    text += "\n";
                                }
                                text += msg.text;
                                numShown++;
                            }
                            if (numShown >= maxShown) {
                                break;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return text;
            };
            /**
             * Remove all messages from the control's associated messages array and the message bar
             */
            Edit.prototype.removeMessages = function () {
                var e_2, _a;
                if (this.ReferenceGroup) {
                    this.ReferenceGroup.removeMessages();
                }
                else if ($dyn.length(this.messages) > 0) {
                    try {
                        for (var _b = __values(this.messages), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var messageId = _c.value;
                            $dyn.messageManager.remove(messageId, this.Root.Id);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    this.messages = [];
                    this.HasMessages(false);
                }
            };
            /**
             * Queue the filter command request
             * @param timerLength The number of ms to wait before calling the filter command
             * @param displayedValueSource The control to get the displayed value
             * from to use as a param to the filter command, or in the case of ReplaceOnLookup=No the
             * string that we should filter on instead of the displayed value.
             */
            Edit.prototype.queueFilterFlyout = function (timerLength, displayedValueSource) {
                var _this = this;
                this.autoPresentLookupTimer = $dyn.async(function () {
                    _this.autoPresentLookupTimer = undefined;
                    if ($dyn.ui.isPopupHost(_this)) {
                        var lookupForm = $dyn.context(_this.popupHostElement);
                        if (lookupForm && $dyn.value(lookupForm.IsFormReady)) {
                            var filterValues = _this.displayedValues(false);
                            if (typeof displayedValueSource === "string") {
                                // In the case of ReplaceOnLookup=No, we track the filter value separately
                                filterValues["@activeFilter"] = displayedValueSource;
                            }
                            else if (displayedValueSource && displayedValueSource.displayedValue) {
                                filterValues["@activeFilter"] = displayedValueSource.displayedValue();
                            }
                            _this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                            $dyn.callFunction(lookupForm.Filter, lookupForm, [filterValues]);
                            var rootControlContext = _this.ReferenceGroup ? _this.ReferenceGroup : _this;
                            $dyn.util.activateLoadingAnimation(rootControlContext.element);
                        }
                        else {
                            // Flyout isn't ready yet--re-queue.
                            _this.queueFilterFlyout(timerLength, displayedValueSource);
                        }
                    }
                    else {
                        // Flyout isn't ready yet--re-queue.
                        _this.queueFilterFlyout(timerLength, displayedValueSource);
                    }
                }, timerLength);
            };
            /**
             * Determines if the focus is going from the control to the associated flyout
             * @param event The focus out event on the control
             * @returns Whether or not focus is going to the flyout
             */
            Edit.prototype.isFocusOutTargetFlyout = function (event) {
                var $relatedTarget = $();
                var isFlyoutTarget = false;
                if (event && event.relatedTarget) {
                    $relatedTarget = $(event.relatedTarget);
                }
                else if (document.activeElement) {
                    $relatedTarget = $(document.activeElement);
                }
                if ($relatedTarget.length) {
                    isFlyoutTarget = !$dyn.util.flyout.isClosableFocusRegion($relatedTarget[0]);
                }
                if (!isFlyoutTarget && $dyn.ui.isPopupHost(this) && this.popupHostElement && $relatedTarget.length) {
                    // No-op. Focus is going into the open flyout.
                    isFlyoutTarget = $.contains(this.popupHostElement, $relatedTarget[0]) || $dyn.flyout.flyoutManager.isContainedByFlyoutHierarchy(this.popupHostElement, $relatedTarget[0]);
                }
                return isFlyoutTarget;
            };
            /**
             * Handler for a specific edge case in focusout events.
             * @description The edge case occurs when the lookup is first opened
             * and the grid is resized before any other input is selected. The
             * focus goes from the input to null and another focusout event is
             * fired, closing the lookup.
             * @remarks After the event is intercepted by this check, focus goes to
             * the first item in the lookup grid.
             * @param event The focusout event to examine.
             * @returns True if the event originated from a resize in the
             * lookup.
             */
            Edit.prototype.isResizingInLookup = function (event) {
                var result = false;
                var $popup = $dyn.ui.isPopupHost(this) ? this.Popup() : null;
                if (event && $popup && $popup.length) {
                    var popupContext = $dyn.context($popup[0]);
                    if (popupContext) {
                        var resizeEventTarget = popupContext.popupResizeEventTarget;
                        result = (
                        // Focus is currently in the Input
                        $.contains(this.element, event.target) &&
                            // Focus is going to null or body for IE
                            (event.relatedTarget === null || event.relatedTarget === document.body) &&
                            // The event was caused by a resize event.
                            resizeEventTarget &&
                            // The resize event was targeted to an element in the popup.
                            $.contains(popupContext.element, resizeEventTarget));
                        if (result) {
                            popupContext.popupResizeEventTarget = null;
                        }
                    }
                }
                return result;
            };
            /**
             * Open the lookup associated with this control. If the lookup is already open, set focus into the lookup
             */
            Edit.prototype.openOrFocusLookup = function () {
                if (!$dyn.value(this.ShowFlyout)) {
                    $dyn.setValue(this, "ShowFlyout", true);
                }
                else if ($dyn.ui.isPopupHost(this)) {
                    var lookupForm = $dyn.context(this.popupHostElement);
                    if (lookupForm && $dyn.value(lookupForm.IsFormReady)) {
                        lookupForm.TakeFocus = true;
                        lookupForm.takeFocusToggled = true;
                        lookupForm.takeNavigationFocus();
                    }
                }
            };
            /**
             * Disable auto-presenting of lookups in 'fast data entry' grids, if that property has not been explicitly set on the control
             */
            Edit.prototype.disableAutoPresentLookupForQuickEditGrids = function () {
                if (this.DisableAutoPresentLookup === undefined) {
                    this.DisableAutoPresentLookup = false;
                    if (this.isInGrid()) {
                        var parentElements = this.$inputElement && this.$inputElement.closest(".listRoot");
                        if (parentElements && parentElements.length > 0) {
                            var listControl = $dyn.context(parentElements[0]);
                            if (listControl) {
                                this.DisableAutoPresentLookup = $dyn.value(listControl._fastEdit);
                            }
                        }
                    }
                }
            };
            /**
             * Attempt to open if currently closed or filter lookup based on typing
             * @param event The keyboard event on the control
             */
            Edit.prototype.autoPresentLookup = function (event) {
                var _this = this;
                var timerLength = $dyn.ui.typeAheadTimer;
                if ($dyn.debug.typeAheadTimer !== undefined) {
                    timerLength = $dyn.debug.typeAheadTimer;
                }
                if ($dyn.value(this.ReplaceOnLookup) === false) {
                    if ($dyn.value(this.ShowFlyout)) {
                        // This block is EnhancedTypeAhead => true, but we do nothing when
                        // ReplaceOnLookup => false and ShowFlyout => false so we need to separate it out
                        // tslint:disable-next-line:no-shadowed-variable
                        var displayedValueSource_1 = this.getDisplayedValueSource(event);
                        if (displayedValueSource_1) {
                            var inputElement_1 = displayedValueSource_1.$inputElement[0];
                            // Wait until the next event loop
                            // (after the value of the control has been changed by this keyboard event)
                            setTimeout(function () {
                                var currentValue = displayedValueSource_1.displayedValue();
                                var currentSelectionStart = $dyn.ui.selectionStart(inputElement_1);
                                var currentSelectionEnd = $dyn.ui.selectionEnd(inputElement_1);
                                // The text we are interested in is whatever the user has typed since
                                // they opened the lookup. This range starts at _enhancedTypeAheadSelectionStart
                                // and ends at _enhancedTypeAheadSelectionStart + (currentValue.length - _enhancedTypeAheadValue.length)
                                var filterStartIndex = _this._enhancedTypeAheadSelectionStart;
                                var filterEndIndex = _this._enhancedTypeAheadSelectionStart + (currentValue.length - _this._enhancedTypeAheadValue.length);
                                if (currentSelectionStart < _this._enhancedTypeAheadSelectionStart ||
                                    currentSelectionEnd > filterEndIndex) {
                                    // The cursor has moved outside the range we're interested in filtering.
                                    // Bail out.
                                    $dyn.setValue(_this, "ShowFlyout", false);
                                }
                                else if ($dyn.ui.isTextualKeyEvent(event) ||
                                    event.keyCode === $dyn.ui.KeyCodes.backSpace ||
                                    event.keyCode === $dyn.ui.KeyCodes.deleteKey) {
                                    // Filter the lookup.
                                    var filterValue = currentValue.slice(filterStartIndex, filterEndIndex);
                                    if (filterValue !== _this._previousFilterValue) {
                                        _this.queueFilterFlyout(timerLength, filterValue);
                                    }
                                }
                            });
                        }
                    }
                }
                else if (this.allowTypeAheadLookup(event)) {
                    // Not a relevant short cut or data navigation key press, handle appropriately. Note: Wait a small period of time before opening the flyout or updating the flyout's filter.
                    this.cancelAutoPresentLookupTimer();
                    var displayedValueSource_2 = this.getDisplayedValueSource(event);
                    if ($dyn.value(this.ShowFlyout)) {
                        // Flyout needs to be filtered.
                        this.queueFilterFlyout(timerLength, displayedValueSource_2);
                    }
                    else {
                        if (this.allowAutoPresentLookup(event)) {
                            // Flyout needs to be presented.
                            this.autoPresentLookupTimer = $dyn.async(function () {
                                _this.autoPresentLookupTimer = undefined;
                                var dispValue;
                                if (displayedValueSource_2 && displayedValueSource_2.displayedValue) {
                                    dispValue = displayedValueSource_2.displayedValue();
                                }
                                if (dispValue === undefined || dispValue.length > 0) {
                                    // We don't want to record the lookup as being opened via keyboard since it is auto-opening.
                                    // Set the input type to not specified.
                                    _this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.notSpecified };
                                    $dyn.setValue(_this, "ShowFlyout", true);
                                }
                            }, timerLength);
                        }
                    }
                }
            };
            /**
             * Remove all messages from the control's associated messages array and the message bar asynchronously (used for inputs with client-side validation)
             */
            Edit.prototype.removeMessagesAsync = function () {
                var _this = this;
                $dyn.async(function () {
                    var e_3, _a;
                    if (_this.ReferenceGroup) {
                        _this.ReferenceGroup.removeMessagesAsync();
                    }
                    else if ($dyn.length(_this.messages) > 0) {
                        try {
                            for (var _b = __values(_this.messages), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var messageId = _c.value;
                                if (messageId !== _this._keepMessageID) {
                                    $dyn.messageManager.remove(messageId, _this.Root.Id);
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        _this.messages = [];
                        if (_this._keepMessageID !== null) {
                            _this.messages.push(_this._keepMessageID);
                            _this.HasMessages(true);
                        }
                        else {
                            _this.HasMessages(false);
                        }
                    }
                }, undefined, "Remove messages asynchronously to avoid conflict with UI interactions");
            };
            /**
             * Focus the input element of the control
             */
            Edit.prototype.focusInput = function () {
                if (this.ReferenceGroup) {
                    this.ReferenceGroup.focusFirstChild();
                }
                else if (this.$inputElement) {
                    this.$inputElement.focus();
                }
            };
            /**
             * Cancels the timer we have to request to lookup
             */
            Edit.prototype.cancelAutoPresentLookupTimer = function () {
                if (this.autoPresentLookupTimer) {
                    this.autoPresentLookupTimer.cancel();
                    this.autoPresentLookupTimer = undefined;
                }
            };
            /**
             * Determing if we allow filter in the lookup by typing the in the control
             * @param event The keyboard event on the control
             * @returns Whether or not we allow type ahead filtering
             */
            Edit.prototype.allowTypeAheadLookup = function (event) {
                var allowAutoPresentLookup = false;
                if (!this.ReferenceGroup && // ReferenceGroup will handle presenting the lookup
                    event && !event.isDefaultPrevented() && // Wasn't handled by shortcut system
                    $dyn.value(this.LookupButton) && this.allowUserChanges() && // Can perform a lookup
                    $dyn.ui.isTextualKeyEvent(event) // Maps to an appropriate key
                ) {
                    allowAutoPresentLookup = true;
                }
                return allowAutoPresentLookup;
            };
            /**
             * Determining if we auto open the flyout in response to user typing
             * @param event The keyboard event on the control
             * @returns Whether or not we auto open the flyout
             */
            Edit.prototype.allowAutoPresentLookup = function (event) {
                // Do not autopop lookups when task recording. A lookup that is opened but never interacted with can cause ordering issues
                // when it attempts to close during task guide.
                var isRecording = $dyn.value($dyn.ax.taskRecording.isRecording) && !$dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
                return !isRecording && !$dyn.shell.isPhone && !this.DisableAutoPresentLookup && this.allowTypeAheadLookup(event);
            };
            return Edit;
        }($dyn.ui.Control));
        controls_1.Edit = Edit;
        Edit.prototype.ReferenceGroup = null;
        Edit.prototype.IsFilterable = false;
        Edit.prototype.IsFiltered = false;
        Edit.prototype.IsSorted = false;
        Edit.prototype.BackgroundColor = "";
        Edit.prototype.ForegroundColor = "";
        Edit.prototype.SupportsDefaultAction = true;
        Edit.prototype.IsDefaultActionGridControl = false;
        Edit.prototype.SendKeyToLookup = true;
        Edit.prototype.HelpText = "";
        Edit.prototype.ShowLabel = true;
        Edit.prototype.CanOpenLookupForm = true;
        Edit.prototype.Label = "";
        Edit.prototype.highlyResponsivePopups = true;
        Edit.prototype.LookupButton = false;
        Edit.prototype.ReplaceOnLookup = true;
        Edit.prototype.$inputElement = null;
        // Private properties we want to give a default value to
        // tslint:disable-next-line:no-string-literal
        Edit.prototype["_keepMessageID"] = null;
        $dyn.ui.addObservablePropertiesToPrototype(Edit.prototype, {
            HasMessages: false,
            isFocused: false,
            IsValid: true,
            Required: false,
            ShouldFlyoutTakeFocus: false,
            StatusIndicator: $dyn.ui.StatusIndicator.none,
        });
        $dyn.ui.addPropertiesToPrototype(Edit.prototype, {
            DataSourceName: {
                defaultValue: "",
                observable: true
            },
            DefaultActionEnabled: {
                attribute: "supportsNavigation",
                attributeSetter: $dyn.ui.toggleCssClass,
                defaultValue: false,
                invokeHandlers: false,
                observable: true,
                serialize: true,
            },
            DisplayOptions: {
                converter: $dyn.util.converters.toObject,
                defaultValue: {},
                invokeHandlers: true,
                observable: true
            },
            FieldName: {
                defaultValue: "",
                observable: true
            },
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Edit.js.map
